import {isChooseMultipleSeatsMode, isChooseSeatMode} from '../../../../../selectors/navigation'
import {getSelectedPlaceId} from '../../../../../selectors/seating/mode'
import {getPlaceStock} from '../../../../../selectors/seating/place'
import {getOrderRemainder, getPlaces} from '../../../../../selectors/seating/places'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {TicketAreaCounterOwnProps, TicketAreaCounterRuntimeProps} from './interfaces'
import {TicketAreaCounter as Presentation} from './ticket-area-counter'

const mapRuntime = (
  {state, actions: {setPlaceDonationError, setSeatingError}}: DetailsPageAppProps,
  {place}: TicketAreaCounterOwnProps,
): TicketAreaCounterRuntimeProps => ({
  setPlaceDonationError,
  setSeatingError,
  placeStock: getPlaceStock(getPlaces(state), place),
  orderRemainder: getOrderRemainder(state, place),
  chooseSeatMode: isChooseSeatMode(state),
  chooseMultipleSeatsMode: isChooseMultipleSeatsMode(state),
  isPlaceSelected: getSelectedPlaceId(state) === place.id,
})

export const TicketAreaCounter = connect<TicketAreaCounterOwnProps, TicketAreaCounterRuntimeProps>(mapRuntime)(
  Presentation,
)
